import React from 'react';

function ImageMarker({ imageSrc, pinColor, borderRadius, onClick, loading }) {
    return (
        <div style={{ display: loading ? 'none' : 'block', position: 'relative', width: 32, filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))' }} onClick={onClick}>
            <img
                src={imageSrc}
                style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: borderRadius,
                    position: 'relative',
                    zIndex: 1
                }}
            />
            <div
                style={{
                    position: 'absolute',
                    bottom: -4,
                    left: '50%',
                    width: 0,
                    height: 0,
                    borderLeft: '12px solid transparent',
                    borderRight: '12px solid transparent',
                    borderTop: `12px solid ${pinColor}`,
                    transform: 'translateX(-50%)'
                }}
            />
        </div>
    );
}

export default ImageMarker;
